export default {"src":"/_next/static/media/x-black.6f461ee7.svg","height":15,"width":15};